import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AuditLog() {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const res = await api.get("/admin/audit-log");
                setLogs(res.data || []);
            } catch {
                toast.error("Failed to load audit log");
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <div className="space-y-6" data-testid="audit-log-page">
            <div>
                <div className="text-xs uppercase tracking-widest text-slate-500">Audit log</div>
                <h1 className="font-heading text-3xl font-bold text-slate-900 mt-1">Access & activity</h1>
                <p className="text-sm text-slate-500 mt-1">Every access to sensitive resources is recorded for compliance.</p>
            </div>

            <div className="border border-slate-200 rounded-lg bg-white overflow-x-auto">
                <table className="w-full text-sm" data-testid="audit-table">
                    <thead>
                        <tr className="border-b border-slate-200 bg-slate-50">
                            <th className="table-header-cell">When</th>
                            <th className="table-header-cell">Actor</th>
                            <th className="table-header-cell">Action</th>
                            <th className="table-header-cell">Resource</th>
                            <th className="table-header-cell">Visibility</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && <tr><td colSpan={5} className="table-cell-tight text-slate-500">Loading…</td></tr>}
                        {!loading && logs.length === 0 && <tr><td colSpan={5} className="table-cell-tight text-slate-500">No audit entries yet.</td></tr>}
                        {logs.map((l) => (
                            <tr key={l.id} className="border-b border-slate-100" data-testid={`audit-row-${l.id}`}>
                                <td className="table-cell-tight text-slate-500">{new Date(l.timestamp).toLocaleString()}</td>
                                <td className="table-cell-tight text-slate-700">{l.actor_email}</td>
                                <td className="table-cell-tight font-medium text-slate-900">{l.action}</td>
                                <td className="table-cell-tight text-slate-700">{l.resource_type}: <span className="font-mono text-xs">{(l.resource_id || "").slice(0, 8)}</span></td>
                                <td className="table-cell-tight text-slate-600 text-xs">{l.visibility || "—"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
